module.exports = __webpack_public_path__ + "fdceb811f79b980f0973623a10c7775a.jpg";